// extracted by mini-css-extract-plugin
export default {"spinner":"spinner___398f0","placeholderShimmer":"placeholderShimmer___3khe8"};